import React, { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../../Context";

const TOTAL_STEPS = 8;

const SuchauftragSection = ({ compact }) => {
  const navigate = useNavigate();
  const { setFilters, filters, setSearchMode } = useApp();

  const [step, setStep] = useState(1);
  const [form, setForm] = useState({
    typ: "",
    art: "",
    plz: "",
    ort: "",
    umkreis: 20,
    wohnflaeche: 60,
    zimmer: 2,
    grundstueck: 300,
    grundstueck2: 500,
    bebauung: "",
    nutzflaeche: 100,
    gewerbeart: "",
    kaufpreis_max: 400000,
    kaltmiete_max: 1000,
    finanz: "",
    wunsch: [],
    termin: "",
    vorname: "",
    nachname: "",
    email: "",
    telefon: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const updateField = useCallback((key, val) => {
    setForm((prev) => ({ ...prev, [key]: val }));
  }, []);

  const go = (n) => {
    setStep(n);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const pct = Math.round(((step - 1) / TOTAL_STEPS) * 100);

  const handleTyp = (val) => {
    updateField("typ", val);
  };

  const handleArt = (val) => {
    updateField("art", val);
  };

  const handleSubmit = () => {
    // Daten in den Context-Filter übernehmen
    setFilters((prev) => ({
      ...prev,
      city: form.ort,
      minPrice:
        form.art === "Kaufen" || form.art === "Beides"
          ? undefined
          : undefined,
      maxPrice:
        form.art === "Kaufen" || form.art === "Beides"
          ? form.kaufpreis_max
          : form.kaltmiete_max,
      advertise_type:
        form.art === "Kaufen"
          ? "Kaufen"
          : form.art === "Mieten"
          ? "Mieten"
          : "",
      category:
        form.typ === "Wohnung"
          ? "Wohnung"
          : form.typ === "Haus"
          ? "Haus"
          : form.typ === "Grundstück"
          ? "Grundstück"
          : "Gewerbe/Industrie",
      name: `${form.vorname} ${form.nachname}`,
      mail: form.email,
      notes: `Suchauftrag: ${form.typ}, ${form.art}, ${form.ort} Umkreis ${
        form.umkreis
      }km, ${form.zimmer} Zimmer, ${form.wohnflaeche}m², max ${
        form.art === "Mieten"
          ? form.kaltmiete_max + "€ Miete"
          : form.kaufpreis_max.toLocaleString("de-DE") + "€ Kauf"
      }, Einzug: ${form.termin}`,
    }));
    setSearchMode("create-request");
    setSubmitted(true);
  };

  // Schließen und zur Filter-Seite navigieren
  const handleFinish = () => {
    navigate("/filter");
  };

  // ==================== STEP RENDERERS ====================

  const renderStep1 = () => (
    <div className="step active" key="s1">
      <h2 className="suchauftrag-q">
        Was suchen <span className="suchauftrag-q-italic">Sie?</span>
      </h2>
      <p className="suchauftrag-sub">Immobilientyp auswählen</p>
      <div className="suchauftrag-icon-grid">
        {[
          {
            val: "Wohnung",
            label: "Wohnung",
            svg: (
              <svg viewBox="0 0 60 60" fill="none">
                <rect
                  x="8"
                  y="18"
                  width="44"
                  height="36"
                  rx="1"
                  stroke="#0a0a0a"
                  strokeWidth="1.4"
                />
                <rect
                  x="4"
                  y="13"
                  width="52"
                  height="7"
                  rx=".5"
                  stroke="#0a0a0a"
                  strokeWidth="1.4"
                />
                <rect
                  x="42"
                  y="6"
                  width="6"
                  height="9"
                  rx=".5"
                  stroke="#0a0a0a"
                  strokeWidth="1.2"
                />
                <rect
                  x="11"
                  y="25"
                  width="9"
                  height="7"
                  rx=".5"
                  stroke="#0a0a0a"
                  strokeWidth="1.1"
                />
                <rect
                  x="25"
                  y="25"
                  width="9"
                  height="7"
                  rx=".5"
                  stroke="#0a0a0a"
                  strokeWidth="1.1"
                />
                <rect
                  x="40"
                  y="25"
                  width="9"
                  height="7"
                  rx=".5"
                  stroke="#0a0a0a"
                  strokeWidth="1.1"
                />
                <rect
                  x="11"
                  y="37"
                  width="9"
                  height="7"
                  rx=".5"
                  stroke="#0a0a0a"
                  strokeWidth="1.1"
                />
                <rect
                  x="25"
                  y="37"
                  width="9"
                  height="7"
                  rx=".5"
                  stroke="#0a0a0a"
                  strokeWidth="1.1"
                />
                <rect
                  x="40"
                  y="37"
                  width="9"
                  height="7"
                  rx=".5"
                  stroke="#0a0a0a"
                  strokeWidth="1.1"
                />
                <rect
                  x="22"
                  y="45"
                  width="16"
                  height="9"
                  rx=".5"
                  stroke="#0a0a0a"
                  strokeWidth="1.1"
                />
                <circle cx="35" cy="50" r="1" fill="#0a0a0a" />
              </svg>
            ),
          },
          {
            val: "Haus",
            label: "Haus",
            svg: (
              <svg viewBox="0 0 60 60" fill="none">
                <rect
                  x="8"
                  y="32"
                  width="44"
                  height="24"
                  rx="1"
                  stroke="#0a0a0a"
                  strokeWidth="1.4"
                />
                <path
                  d="M4 33 L30 8 L56 33"
                  stroke="#0a0a0a"
                  strokeWidth="1.4"
                  strokeLinejoin="round"
                />
                <rect
                  x="40"
                  y="14"
                  width="7"
                  height="12"
                  rx=".5"
                  stroke="#0a0a0a"
                  strokeWidth="1.2"
                />
                <rect
                  x="11"
                  y="39"
                  width="12"
                  height="10"
                  rx=".5"
                  stroke="#0a0a0a"
                  strokeWidth="1.1"
                />
                <line
                  x1="17"
                  y1="39"
                  x2="17"
                  y2="49"
                  stroke="#0a0a0a"
                  strokeWidth=".7"
                />
                <line
                  x1="11"
                  y1="44"
                  x2="23"
                  y2="44"
                  stroke="#0a0a0a"
                  strokeWidth=".7"
                />
                <rect
                  x="37"
                  y="39"
                  width="12"
                  height="10"
                  rx=".5"
                  stroke="#0a0a0a"
                  strokeWidth="1.1"
                />
                <line
                  x1="43"
                  y1="39"
                  x2="43"
                  y2="49"
                  stroke="#0a0a0a"
                  strokeWidth=".7"
                />
                <line
                  x1="37"
                  y1="44"
                  x2="49"
                  y2="44"
                  stroke="#0a0a0a"
                  strokeWidth=".7"
                />
                <rect
                  x="22"
                  y="44"
                  width="16"
                  height="12"
                  rx=".5"
                  stroke="#0a0a0a"
                  strokeWidth="1.1"
                />
                <circle cx="35" cy="51" r="1" fill="#0a0a0a" />
              </svg>
            ),
          },
          {
            val: "Grundstück",
            label: "Grundstück",
            svg: (
              <svg viewBox="0 0 60 60" fill="none">
                <path
                  d="M30 52 L8 36 L30 20 L52 36 Z"
                  stroke="#0a0a0a"
                  strokeWidth="1.4"
                  strokeLinejoin="round"
                />
                <line
                  x1="19"
                  y1="28"
                  x2="41"
                  y2="44"
                  stroke="#0a0a0a"
                  strokeWidth=".6"
                  strokeDasharray="3 2.5"
                />
                <line
                  x1="41"
                  y1="28"
                  x2="19"
                  y2="44"
                  stroke="#0a0a0a"
                  strokeWidth=".6"
                  strokeDasharray="3 2.5"
                />
                <circle
                  cx="30"
                  cy="28"
                  r="7.5"
                  stroke="#0a0a0a"
                  strokeWidth="1.3"
                />
                <circle cx="30" cy="28" r="2.5" fill="#0a0a0a" />
                <line
                  x1="30"
                  y1="35.5"
                  x2="30"
                  y2="42"
                  stroke="#0a0a0a"
                  strokeWidth="1.3"
                  strokeLinecap="round"
                />
              </svg>
            ),
          },
          {
            val: "Gewerbe",
            label: "Gewerbe",
            svg: (
              <svg viewBox="0 0 60 60" fill="none">
                <rect
                  x="4"
                  y="28"
                  width="52"
                  height="28"
                  rx="1"
                  stroke="#0a0a0a"
                  strokeWidth="1.4"
                />
                <rect
                  x="4"
                  y="22"
                  width="52"
                  height="8"
                  rx=".5"
                  stroke="#0a0a0a"
                  strokeWidth="1.4"
                />
                <rect
                  x="4"
                  y="14"
                  width="22"
                  height="10"
                  rx=".5"
                  stroke="#0a0a0a"
                  strokeWidth="1.2"
                />
                <rect
                  x="8"
                  y="6"
                  width="5"
                  height="10"
                  rx=".5"
                  stroke="#0a0a0a"
                  strokeWidth="1.1"
                />
                <rect
                  x="15"
                  y="4"
                  width="5"
                  height="12"
                  rx=".5"
                  stroke="#0a0a0a"
                  strokeWidth="1.1"
                />
                <rect
                  x="10"
                  y="34"
                  width="12"
                  height="22"
                  rx=".5"
                  stroke="#0a0a0a"
                  strokeWidth="1.1"
                />
                <rect
                  x="28"
                  y="34"
                  width="12"
                  height="22"
                  rx=".5"
                  stroke="#0a0a0a"
                  strokeWidth="1.1"
                />
                <rect
                  x="46"
                  y="34"
                  width="10"
                  height="22"
                  rx=".5"
                  stroke="#0a0a0a"
                  strokeWidth="1.1"
                />
              </svg>
            ),
          },
        ].map((item) => (
          <div
            key={item.val}
            className={`suchauftrag-icon-card${
              form.typ === item.val ? " sel" : ""
            }`}
            onClick={() => handleTyp(item.val)}
          >
            {item.svg}
            <span className="suchauftrag-icon-card-label">{item.label}</span>
          </div>
        ))}
      </div>
      <div className="suchauftrag-nav">
        <span />
        <button
          className="suchauftrag-btn-next"
          disabled={!form.typ}
          onClick={() => go(2)}
        >
          Weiter
        </button>
      </div>
    </div>
  );

  const renderStep2 = () => (
    <div className="step active" key="s2">
      <h2 className="suchauftrag-q">
        Kaufen oder <span className="suchauftrag-q-italic">mieten?</span>
      </h2>
      <p className="suchauftrag-sub">Ihre Absicht</p>
      <div className="suchauftrag-big-select">
        {[
          { num: "01", title: "Kaufen", desc: "Ich möchte eine Immobilie erwerben" },
          { num: "02", title: "Mieten", desc: "Ich suche eine Mietimmobilie" },
          {
            num: "03",
            title: "Beides",
            desc: "Ich bin für beide Optionen offen",
          },
        ].map((item) => (
          <div
            key={item.title}
            className={`suchauftrag-big-opt${form.art === item.title ? " sel" : ""}`}
            onClick={() => handleArt(item.title)}
          >
            <div className="suchauftrag-big-opt-num">{item.num}</div>
            <div className="suchauftrag-big-opt-body">
              <div className="suchauftrag-big-opt-title">{item.title}</div>
              <div className="suchauftrag-big-opt-desc">{item.desc}</div>
            </div>
          </div>
        ))}
      </div>
      <div className="suchauftrag-nav">
        <button className="suchauftrag-btn-back" onClick={() => go(1)}>
          ← Zurück
        </button>
        <button
          className="suchauftrag-btn-next"
          disabled={!form.art}
          onClick={() => go(3)}
        >
          Weiter
        </button>
      </div>
    </div>
  );

  const renderStep3 = () => (
    <div className="step active" key="s3">
      <h2 className="suchauftrag-q">
        Wo suchen <span className="suchauftrag-q-italic">Sie?</span>
      </h2>
      <p className="suchauftrag-sub">Ihr Wunschgebiet</p>
      <div className="suchauftrag-row2">
        <div className="suchauftrag-input-group">
          <label className="suchauftrag-lbl">Postleitzahl</label>
          <input
            className="suchauftrag-field"
            type="text"
            placeholder="70000"
            maxLength={5}
            value={form.plz}
            onChange={(e) => updateField("plz", e.target.value)}
          />
        </div>
        <div className="suchauftrag-input-group">
          <label className="suchauftrag-lbl">Ort</label>
          <input
            className="suchauftrag-field"
            type="text"
            placeholder="Stuttgart"
            value={form.ort}
            onChange={(e) => updateField("ort", e.target.value)}
          />
        </div>
      </div>
      <div className="suchauftrag-slider-wrap">
        <label className="suchauftrag-lbl">Umkreis</label>
        <div className="suchauftrag-slider-val">
          {form.umkreis} <span>km</span>
        </div>
        <input
          type="range"
          min="5"
          max="100"
          step="5"
          value={form.umkreis}
          onChange={(e) => updateField("umkreis", parseInt(e.target.value))}
          className="suchauftrag-range"
        />
        <div className="suchauftrag-slider-range">
          <span>5 km</span>
          <span>100 km</span>
        </div>
      </div>
      <div className="suchauftrag-nav">
        <button className="suchauftrag-btn-back" onClick={() => go(2)}>
          ← Zurück
        </button>
        <button
          className="suchauftrag-btn-next"
          disabled={form.plz.length < 4 || form.ort.trim().length < 2}
          onClick={() => go(4)}
        >
          Weiter
        </button>
      </div>
    </div>
  );

  const renderStep4 = () => (
    <div className="step active" key="s4">
      <h2 className="suchauftrag-q">
        Wie groß soll <span className="suchauftrag-q-italic">die Immobilie sein?</span>
      </h2>
      <p className="suchauftrag-sub">Mindestanforderungen</p>

      {/* Wohnung / Haus */}
      {(form.typ === "Wohnung" || form.typ === "Haus") && (
        <>
          <div className="suchauftrag-slider-wrap">
            <label className="suchauftrag-lbl">Wohnfläche mindestens</label>
            <div className="suchauftrag-slider-val">
              {form.wohnflaeche} <span>m²</span>
            </div>
            <input
              type="range"
              min="20"
              max="300"
              step="5"
              value={form.wohnflaeche}
              onChange={(e) => updateField("wohnflaeche", parseInt(e.target.value))}
              className="suchauftrag-range"
            />
            <div className="suchauftrag-slider-range">
              <span>20 m²</span>
              <span>300 m²</span>
            </div>
          </div>
          <div className="suchauftrag-slider-wrap">
            <label className="suchauftrag-lbl">Zimmer mindestens</label>
            <div className="suchauftrag-slider-val">
              {form.zimmer} <span>Zimmer</span>
            </div>
            <input
              type="range"
              min="1"
              max="10"
              step="1"
              value={form.zimmer}
              onChange={(e) => updateField("zimmer", parseInt(e.target.value))}
              className="suchauftrag-range"
            />
            <div className="suchauftrag-slider-range">
              <span>1</span>
              <span>10+</span>
            </div>
          </div>
        </>
      )}

      {/* Haus zusätzlich Grundstück */}
      {form.typ === "Haus" && (
        <div className="suchauftrag-slider-wrap">
          <label className="suchauftrag-lbl">Grundstück mindestens</label>
          <div className="suchauftrag-slider-val">
            {form.grundstueck} <span>m²</span>
          </div>
          <input
            type="range"
            min="100"
            max="5000"
            step="50"
            value={form.grundstueck}
            onChange={(e) => updateField("grundstueck", parseInt(e.target.value))}
            className="suchauftrag-range"
          />
          <div className="suchauftrag-slider-range">
            <span>100 m²</span>
            <span>5.000 m²</span>
          </div>
        </div>
      )}

      {/* Grundstück */}
      {form.typ === "Grundstück" && (
        <>
          <div className="suchauftrag-info-box">
            Für Grundstücke sind Fläche und Bebaubarkeit die entscheidenden Suchkriterien.
          </div>
          <div className="suchauftrag-slider-wrap">
            <label className="suchauftrag-lbl">Grundstücksgröße mindestens</label>
            <div className="suchauftrag-slider-val">
              {form.grundstueck2} <span>m²</span>
            </div>
            <input
              type="range"
              min="100"
              max="10000"
              step="100"
              value={form.grundstueck2}
              onChange={(e) => updateField("grundstueck2", parseInt(e.target.value))}
              className="suchauftrag-range"
            />
            <div className="suchauftrag-slider-range">
              <span>100 m²</span>
              <span>10.000 m²</span>
            </div>
          </div>
          <div className="suchauftrag-input-group">
            <label className="suchauftrag-lbl">Gewünschte Bebauungsart</label>
            <div className="suchauftrag-chips">
              {["Wohnbebauung", "Gewerbe", "Gemischt", "Egal"].map((b) => (
                <div
                  key={b}
                  className={`suchauftrag-chip${form.bebauung === b ? " sel" : ""}`}
                  onClick={() => updateField("bebauung", b)}
                >
                  {b}
                </div>
              ))}
            </div>
          </div>
        </>
      )}

      {/* Gewerbe */}
      {form.typ === "Gewerbe" && (
        <>
          <div className="suchauftrag-slider-wrap">
            <label className="suchauftrag-lbl">Nutzfläche mindestens</label>
            <div className="suchauftrag-slider-val">
              {form.nutzflaeche} <span>m²</span>
            </div>
            <input
              type="range"
              min="20"
              max="2000"
              step="20"
              value={form.nutzflaeche}
              onChange={(e) => updateField("nutzflaeche", parseInt(e.target.value))}
              className="suchauftrag-range"
            />
            <div className="suchauftrag-slider-range">
              <span>20 m²</span>
              <span>2.000 m²</span>
            </div>
          </div>
          <div className="suchauftrag-input-group">
            <label className="suchauftrag-lbl">Gewerbeart</label>
            <div className="suchauftrag-chips">
              {["Büro / Praxis", "Einzelhandel", "Lager / Halle", "Gastronomie", "Egal"].map(
                (g) => (
                  <div
                    key={g}
                    className={`suchauftrag-chip${form.gewerbeart === g ? " sel" : ""}`}
                    onClick={() => updateField("gewerbeart", g)}
                  >
                    {g}
                  </div>
                )
              )}
            </div>
          </div>
        </>
      )}

      <div className="suchauftrag-nav">
        <button className="suchauftrag-btn-back" onClick={() => go(3)}>
          ← Zurück
        </button>
        <button className="suchauftrag-btn-next" onClick={() => go(5)}>
          Weiter
        </button>
      </div>
    </div>
  );

  const renderStep5 = () => (
    <div className="step active" key="s5">
      <h2 className="suchauftrag-q">
        Was ist Ihr <span className="suchauftrag-q-italic">Budget?</span>
      </h2>
      <p className="suchauftrag-sub">Maximales Budget</p>

      {(form.art === "Kaufen" || form.art === "Beides") && (
        <div className="suchauftrag-slider-wrap">
          <label className="suchauftrag-lbl">Kaufpreis bis</label>
          <div className="suchauftrag-slider-val">
            {form.kaufpreis_max.toLocaleString("de-DE")} <span>€</span>
          </div>
          <input
            type="range"
            min="50000"
            max="2000000"
            step="25000"
            value={form.kaufpreis_max}
            onChange={(e) => updateField("kaufpreis_max", parseInt(e.target.value))}
            className="suchauftrag-range"
          />
          <div className="suchauftrag-slider-range">
            <span>50.000 €</span>
            <span>2.000.000 €</span>
          </div>
        </div>
      )}

      {(form.art === "Mieten" || form.art === "Beides") && (
        <div className="suchauftrag-slider-wrap">
          <label className="suchauftrag-lbl">Kaltmiete bis</label>
          <div className="suchauftrag-slider-val">
            {form.kaltmiete_max} <span>€/Monat</span>
          </div>
          <input
            type="range"
            min="300"
            max="5000"
            step="50"
            value={form.kaltmiete_max}
            onChange={(e) => updateField("kaltmiete_max", parseInt(e.target.value))}
            className="suchauftrag-range"
          />
          <div className="suchauftrag-slider-range">
            <span>300 €</span>
            <span>5.000 €</span>
          </div>
        </div>
      )}

      {form.art !== "Mieten" && (
        <>
          <label className="suchauftrag-lbl" style={{ marginBottom: 14, display: "block" }}>
            Finanzierung bereits geklärt?
          </label>
          <div className="suchauftrag-big-select">
            {[
              { num: "01", title: "Ja — Finanzierungszusage liegt vor", desc: "Bank hat bereits grünes Licht gegeben" },
              { num: "02", title: "Nein — noch in Planung", desc: "Finanzierung wird parallel geklärt" },
              { num: "03", title: "Barzahler", desc: "Kauf ohne Finanzierung geplant" },
            ].map((item) => (
              <div
                key={item.title}
                className={`suchauftrag-big-opt${form.finanz === item.title ? " sel" : ""}`}
                onClick={() => updateField("finanz", item.title)}
              >
                <div className="suchauftrag-big-opt-num">{item.num}</div>
                <div className="suchauftrag-big-opt-body">
                  <div className="suchauftrag-big-opt-title">{item.title}</div>
                  <div className="suchauftrag-big-opt-desc">{item.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      <div className="suchauftrag-nav">
        <button className="suchauftrag-btn-back" onClick={() => go(4)}>
          ← Zurück
        </button>
        <button
          className="suchauftrag-btn-next"
          disabled={
            form.art !== "Mieten" && !form.finanz
          }
          onClick={() => go(6)}
        >
          Weiter
        </button>
      </div>
    </div>
  );

  const renderStep6 = () => (
    <div className="step active" key="s6">
      <h2 className="suchauftrag-q">
        Was ist Ihnen <span className="suchauftrag-q-italic">wichtig?</span>
      </h2>
      <p className="suchauftrag-sub">Mehrfachauswahl — kein Pflichtfeld</p>

      {(form.typ === "Wohnung" || form.typ === "Haus") && (
        <div className="suchauftrag-chips">
          {[
            "Einbauküche",
            "Keller",
            "Garage / Stellplatz",
            "Garten",
            "Balkon / Terrasse",
            "Aufzug",
            "Barrierefrei",
            "Fußbodenheizung",
            "Neubau bevorzugt",
            "Ruhige Lage",
            "Stadtzentrumsnähe",
            "Gute Schulen in der Nähe",
          ].map((w) => (
            <div
              key={w}
              className={`suchauftrag-chip${form.wunsch.includes(w) ? " sel" : ""}`}
              onClick={() => {
                const arr = [...form.wunsch];
                if (arr.includes(w)) {
                  updateField("wunsch", arr.filter((x) => x !== w));
                } else {
                  updateField("wunsch", [...arr, w]);
                }
              }}
            >
              {w}
            </div>
          ))}
        </div>
      )}

      {form.typ === "Grundstück" && (
        <div className="suchauftrag-chips">
          {[
            "Erschlossen",
            "Ruhige Lage",
            "Südausrichtung",
            "Bebauungsplan vorhanden",
            "Stadtzentrumsnähe",
          ].map((w) => (
            <div
              key={w}
              className={`suchauftrag-chip${form.wunsch.includes(w) ? " sel" : ""}`}
              onClick={() => {
                const arr = [...form.wunsch];
                if (arr.includes(w)) {
                  updateField("wunsch", arr.filter((x) => x !== w));
                } else {
                  updateField("wunsch", [...arr, w]);
                }
              }}
            >
              {w}
            </div>
          ))}
        </div>
      )}

      {form.typ === "Gewerbe" && (
        <div className="suchauftrag-chips">
          {[
            "Klimaanlage",
            "Lastenaufzug",
            "Rampe / Verladetor",
            "Stellplätze",
            "Barrierefrei",
            "Schaufenster",
          ].map((w) => (
            <div
              key={w}
              className={`suchauftrag-chip${form.wunsch.includes(w) ? " sel" : ""}`}
              onClick={() => {
                const arr = [...form.wunsch];
                if (arr.includes(w)) {
                  updateField("wunsch", arr.filter((x) => x !== w));
                } else {
                  updateField("wunsch", [...arr, w]);
                }
              }}
            >
              {w}
            </div>
          ))}
        </div>
      )}

      <div className="suchauftrag-nav">
        <button className="suchauftrag-btn-back" onClick={() => go(5)}>
          ← Zurück
        </button>
        <button className="suchauftrag-btn-next" onClick={() => go(7)}>
          Weiter
        </button>
      </div>
    </div>
  );

  const renderStep7 = () => (
    <div className="step active" key="s7">
      <h2 className="suchauftrag-q">
        Wann möchten Sie <span className="suchauftrag-q-italic">einziehen?</span>
      </h2>
      <p className="suchauftrag-sub">Gewünschter Zeitrahmen</p>
      <div className="suchauftrag-big-select">
        {[
          { num: "01", title: "Sofort", desc: "So schnell wie möglich" },
          { num: "02", title: "In 3–6 Monaten", desc: "Konkrete Planung vorhanden" },
          { num: "03", title: "In 6–12 Monaten", desc: "Mittelfristige Planung" },
          { num: "04", title: "Flexibel", desc: "Kein fester Termin" },
        ].map((item) => (
          <div
            key={item.title}
            className={`suchauftrag-big-opt${form.termin === item.title ? " sel" : ""}`}
            onClick={() => updateField("termin", item.title)}
          >
            <div className="suchauftrag-big-opt-num">{item.num}</div>
            <div className="suchauftrag-big-opt-body">
              <div className="suchauftrag-big-opt-title">{item.title}</div>
              <div className="suchauftrag-big-opt-desc">{item.desc}</div>
            </div>
          </div>
        ))}
      </div>
      <div className="suchauftrag-nav">
        <button className="suchauftrag-btn-back" onClick={() => go(6)}>
          ← Zurück
        </button>
        <button
          className="suchauftrag-btn-next"
          disabled={!form.termin}
          onClick={() => go(8)}
        >
          Weiter
        </button>
      </div>
    </div>
  );

  const renderStep8 = () => (
    <div className="step active" key="s8">
      <h2 className="suchauftrag-q">
        Wie erreichen wir <span className="suchauftrag-q-italic">Sie?</span>
      </h2>
      <p className="suchauftrag-sub">Ihre Kontaktdaten</p>
      <div className="suchauftrag-row2">
        <div className="suchauftrag-input-group">
          <label className="suchauftrag-lbl">Vorname</label>
          <input
            className="suchauftrag-field"
            type="text"
            placeholder="Max"
            value={form.vorname}
            onChange={(e) => updateField("vorname", e.target.value)}
          />
        </div>
        <div className="suchauftrag-input-group">
          <label className="suchauftrag-lbl">Nachname</label>
          <input
            className="suchauftrag-field"
            type="text"
            placeholder="Mustermann"
            value={form.nachname}
            onChange={(e) => updateField("nachname", e.target.value)}
          />
        </div>
      </div>
      <div className="suchauftrag-input-group">
        <label className="suchauftrag-lbl">E-Mail-Adresse</label>
        <input
          className="suchauftrag-field"
          type="email"
          placeholder="max@beispiel.de"
          value={form.email}
          onChange={(e) => updateField("email", e.target.value)}
        />
      </div>
      <div className="suchauftrag-input-group">
        <label className="suchauftrag-lbl">
          Telefon <span className="suchauftrag-lbl-opt">(optional)</span>
        </label>
        <input
          className="suchauftrag-field"
          type="tel"
          placeholder="+49 711 …"
          value={form.telefon}
          onChange={(e) => updateField("telefon", e.target.value)}
        />
      </div>

      <div className="suchauftrag-trust">
        <div className="suchauftrag-trust-item">
          <svg className="suchauftrag-trust-icon" viewBox="0 0 18 18" fill="none">
            <circle cx="9" cy="9" r="8" stroke="#2F5BFF" strokeWidth="1.2" />
            <path d="M5 9l3 3 5-5" stroke="#2F5BFF" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <span className="suchauftrag-trust-text">100 % kostenlos & unverbindlich</span>
        </div>
        <div className="suchauftrag-trust-item">
          <svg className="suchauftrag-trust-icon" viewBox="0 0 18 18" fill="none">
            <rect x="3" y="7" width="12" height="9" rx="1" stroke="#2F5BFF" strokeWidth="1.2" />
            <path d="M6 7V5a3 3 0 016 0v2" stroke="#2F5BFF" strokeWidth="1.2" strokeLinecap="round" />
          </svg>
          <span className="suchauftrag-trust-text">DSGVO-konform</span>
        </div>
        <div className="suchauftrag-trust-item">
          <svg className="suchauftrag-trust-icon" viewBox="0 0 18 18" fill="none">
            <circle cx="9" cy="9" r="8" stroke="#2F5BFF" strokeWidth="1.2" />
            <path d="M9 5v4l3 2" stroke="#2F5BFF" strokeWidth="1.3" strokeLinecap="round" />
          </svg>
          <span className="suchauftrag-trust-text">Antwort innerhalb 24 h</span>
        </div>
      </div>

      <div className="suchauftrag-nav">
        <button className="suchauftrag-btn-back" onClick={() => go(7)}>
          ← Zurück
        </button>
        <button
          className="suchauftrag-btn-next"
          disabled={
            form.vorname.trim().length === 0 ||
            form.nachname.trim().length === 0 ||
            !form.email.includes("@") ||
            !form.email.includes(".")
          }
          onClick={handleSubmit}
        >
          Suchauftrag absenden
        </button>
      </div>
      <p className="suchauftrag-dsgvo-hinweis">
        Mit dem Absenden stimmen Sie der Verarbeitung Ihrer Daten gemäß unserer
        Datenschutzerklärung zu (jederzeit widerrufbar).
      </p>
    </div>
  );

  const renderConfirmation = () => (
    <div className="step active" key="s9">
      <div className="suchauftrag-confirm">
        <div className="suchauftrag-confirm-ring">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
            <path d="M5 12l5 5L19 7" stroke="#E85D20" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <h2 className="suchauftrag-confirm-title">Suchauftrag eingegangen.</h2>
        <p className="suchauftrag-confirm-sub">
          Wir haben Ihr Suchprofil erhalten und melden uns innerhalb von 24 Stunden mit
          passenden Angeboten.
        </p>
        <div className="suchauftrag-confirm-dsgvo">
          Vielen Dank für Ihr Vertrauen. Wir werden Ihre Anfrage anonymisiert — ohne Nennung
          Ihres Namens oder Ihrer Kontaktdaten — an geprüfte Makler und Privatpersonen in Ihrem
          Suchgebiet weiterleiten. Nur wenn ein Angebot Ihren Kriterien entspricht, nehmen wir
          Kontakt mit Ihnen auf. Ihre Daten werden ausschließlich zur Bearbeitung Ihres
          Suchauftrags verwendet und nicht ohne Ihre ausdrückliche Zustimmung an Dritte
          weitergegeben (Art. 6 Abs. 1 lit. b DSGVO).
        </div>
        <div className="suchauftrag-confirm-hr" />
        <div className="suchauftrag-confirm-steps">
          <div className="suchauftrag-confirm-step">
            <div className="suchauftrag-confirm-step-num">1</div>
            <div className="suchauftrag-confirm-step-text">
              Bestätigungs-E-Mail erhalten
              <span>In wenigen Minuten in Ihrem Postfach</span>
            </div>
          </div>
          <div className="suchauftrag-confirm-step">
            <div className="suchauftrag-confirm-step-num">2</div>
            <div className="suchauftrag-confirm-step-text">
              Passende Angebote per E-Mail
              <span>Sobald Objekte Ihren Kriterien entsprechen</span>
            </div>
          </div>
          <div className="suchauftrag-confirm-step">
            <div className="suchauftrag-confirm-step-num">3</div>
            <div className="suchauftrag-confirm-step-text">
              Persönliche Beratung auf Wunsch
              <span>Unverbindlich — Sie entscheiden</span>
            </div>
          </div>
        </div>
        <p className="suchauftrag-confirm-footer">
          Sie können Ihren Suchauftrag jederzeit per E-Mail an{" "}
          <a href="mailto:mail@immointerest.de">mail@immointerest.de</a> widerrufen.
        </p>

        <button
          className="suchauftrag-btn-next"
          style={{ marginTop: 32 }}
          onClick={handleFinish}
        >
          Zu den Immobilien
        </button>
      </div>
    </div>
  );

  const renderCurrentStep = () => {
    if (submitted) return renderConfirmation();
    switch (step) {
      case 1: return renderStep1();
      case 2: return renderStep2();
      case 3: return renderStep3();
      case 4: return renderStep4();
      case 5: return renderStep5();
      case 6: return renderStep6();
      case 7: return renderStep7();
      case 8: return renderStep8();
      default: return renderStep1();
    }
  };

  return (
    <>
      <style>{`
        .suchauftrag-hero {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 48px 20px 80px;
        }
        .suchauftrag-hero.compact {
          min-height: auto;
          padding: 0;
          align-items: flex-end;
          justify-content: center;
        }
        .suchauftrag-inner {
          width: 100%;
          max-width: 580px;
          background: #fff;
          border: 1px solid #E3E7F1;
          border-radius: 24px;
          padding: 40px 40px 36px;
          box-shadow: 0 18px 50px rgba(20,40,120,.07);
        }
        .suchauftrag-hero.compact .suchauftrag-inner {
          max-width: 480px;
          padding: 28px 28px 24px;
          margin: 0;
        }
        .suchauftrag-hero.compact .suchauftrag-brandblock {
          display: none;
        }
        .suchauftrag-hero.compact .suchauftrag-brand-mark {
          width: 44px;
          height: 44px;
        }
        .suchauftrag-hero.compact .suchauftrag-brand-mark svg {
          width: 28px;
          height: 28px;
        }
        .suchauftrag-hero.compact .suchauftrag-wordmark {
          font-size: 18px;
        }
        .suchauftrag-hero.compact .suchauftrag-kicker {
          font-size: 8px;
        }
        .suchauftrag-hero.compact .suchauftrag-prog-info {
          margin-bottom: 24px;
        }
        .suchauftrag-hero.compact .suchauftrag-q {
          font-size: clamp(1.3rem, 3.5vw, 1.6rem);
        }
        .suchauftrag-hero.compact .suchauftrag-sub {
          margin-bottom: 20px;
          font-size: 13px;
        }
        .suchauftrag-hero.compact .suchauftrag-icon-card {
          padding: 18px 12px 14px;
        }
        .suchauftrag-hero.compact .suchauftrag-icon-card svg {
          width: 40px;
          height: 40px;
        }
        .suchauftrag-hero.compact .suchauftrag-big-opt-num {
          font-size: clamp(1.3rem, 4vw, 1.6rem);
          padding: 12px 14px 12px 16px;
          min-width: 48px;
        }
        .suchauftrag-hero.compact .suchauftrag-big-opt-body {
          padding: 10px 16px 10px 0;
        }
        .suchauftrag-hero.compact .suchauftrag-big-opt-title {
          font-size: 0.9rem;
        }
        .suchauftrag-hero.compact .suchauftrag-big-opt-desc {
          font-size: 11px;
        }
        .suchauftrag-hero.compact .suchauftrag-slider-val {
          font-size: clamp(1.5rem, 4vw, 2rem);
        }
        .suchauftrag-hero.compact .suchauftrag-nav {
          margin-top: 24px;
        }
        .suchauftrag-hero.compact .suchauftrag-btn-next {
          padding: 12px 28px;
          font-size: 14px;
        }
        .suchauftrag-hero.compact .suchauftrag-chip {
          padding: 8px 14px;
          font-size: 13px;
        }
        .suchauftrag-hero.compact .suchauftrag-slider-wrap {
          margin-bottom: 18px;
        }
        .suchauftrag-hero.compact .suchauftrag-trust {
          margin-top: 20px;
          padding-top: 18px;
        }
        .suchauftrag-brandblock {
          text-align: center;
          margin-bottom: 40px;
        }
        .suchauftrag-brand {
          display: inline-flex;
          align-items: center;
          gap: 16px;
          margin-bottom: 14px;
        }
        .suchauftrag-brand-mark {
          width: 58px;
          height: 58px;
          border-radius: 16px;
          background: #2F5BFF;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 8px 22px rgba(20,40,120,.28);
          flex-shrink: 0;
        }
        .suchauftrag-brand-mark svg {
          width: 36px;
          height: 36px;
        }
        .suchauftrag-brand-text {
          display: flex;
          flex-direction: column;
          gap: 6px;
          text-align: left;
        }
        .suchauftrag-wordmark {
          font-size: 24px;
          font-weight: 800;
          letter-spacing: .2px;
          line-height: 1;
          color: #0B1020;
        }
        .suchauftrag-wordmark em {
          font-style: normal;
          color: #FF6A2B;
          margin-left: .32em;
        }
        .suchauftrag-kicker {
          font-size: 10px;
          font-weight: 700;
          letter-spacing: .34em;
          color: #99A1B3;
        }
        .suchauftrag-brand-tag {
          font-size: 11px;
          font-weight: 700;
          letter-spacing: .22em;
          text-transform: uppercase;
          color: #FF6A2B;
        }
        .suchauftrag-prog-track {
          width: 100%;
          height: 5px;
          background: #E3E7F1;
          border-radius: 99px;
          margin-bottom: 9px;
          overflow: hidden;
        }
        .suchauftrag-prog-fill {
          height: 100%;
          background: #FF6A2B;
          border-radius: 99px;
          transition: width .5s cubic-bezier(.4,0,.2,1);
        }
        .suchauftrag-prog-info {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 38px;
          gap: 16px;
        }
        .suchauftrag-prog-text {
          font-size: 11px;
          letter-spacing: .16em;
          text-transform: uppercase;
          color: #6A7385;
          font-weight: 700;
          white-space: nowrap;
        }
        .suchauftrag-prog-pct {
          font-size: 12px;
          letter-spacing: .02em;
          color: #FF6A2B;
          font-weight: 800;
        }
        .step {
          display: none;
        }
        .step.active {
          display: block;
          animation: suchauftragFadeUp .4s ease;
        }
        @keyframes suchauftragFadeUp {
          from { opacity: 0; transform: translateY(14px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .suchauftrag-q {
          font-size: clamp(1.6rem, 4.2vw, 2.05rem);
          font-weight: 800;
          line-height: 1.16;
          letter-spacing: -.02em;
          margin-bottom: 10px;
        }
        .suchauftrag-q-italic {
          font-style: normal;
          font-weight: 800;
          color: #FF6A2B;
        }
        .suchauftrag-sub {
          font-size: 14.5px;
          font-weight: 500;
          color: #6A7385;
          margin-bottom: 32px;
          letter-spacing: 0;
          text-transform: none;
        }
        .suchauftrag-icon-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
          margin-bottom: 8px;
        }
        .suchauftrag-icon-card {
          border: 1.5px solid #E3E7F1;
          border-radius: 16px;
          padding: 26px 16px 20px;
          background: #fff;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 14px;
          cursor: pointer;
          transition: border-color .18s, background .18s;
          user-select: none;
        }
        .suchauftrag-icon-card:hover { border-color: #99A1B3; }
        .suchauftrag-icon-card.sel {
          border-color: #2F5BFF;
          border-width: 1.5px;
          background: #EEF2FF;
        }
        .suchauftrag-icon-card svg { width: 56px; height: 56px; }
        .suchauftrag-icon-card svg [stroke="#0a0a0a"] { stroke: #0B1020; }
        .suchauftrag-icon-card svg [fill="#0a0a0a"] { fill: #0B1020; }
        .suchauftrag-icon-card.sel svg [stroke="#0a0a0a"] { stroke: #2F5BFF; }
        .suchauftrag-icon-card.sel svg [fill="#0a0a0a"] { fill: #2F5BFF; }
        .suchauftrag-icon-card-label {
          font-size: 11px;
          letter-spacing: .16em;
          text-transform: uppercase;
          font-weight: 700;
          color: #0B1020;
        }
        .suchauftrag-big-select {
          display: flex;
          flex-direction: column;
          gap: 10px;
          margin-bottom: 8px;
        }
        .suchauftrag-big-opt {
          display: flex;
          align-items: center;
          border: 1.5px solid #E3E7F1;
          background: #fff;
          border-radius: 14px;
          cursor: pointer;
          transition: border-color .18s, background .18s;
          overflow: hidden;
          user-select: none;
        }
        .suchauftrag-big-opt:hover { border-color: #99A1B3; }
        .suchauftrag-big-opt.sel {
          border-color: #2F5BFF;
          border-width: 1.5px;
          background: #EEF2FF;
        }
        .suchauftrag-big-opt-num {
          font-size: clamp(1.7rem, 5vw, 2.2rem);
          font-weight: 800;
          color: #99A1B3;
          padding: 16px 18px 16px 22px;
          min-width: 64px;
          text-align: center;
          line-height: 1;
          transition: color .18s;
          flex-shrink: 0;
        }
        .suchauftrag-big-opt.sel .suchauftrag-big-opt-num { color: #FF6A2B; }
        .suchauftrag-big-opt-body { padding: 15px 20px 15px 0; flex: 1; }
        .suchauftrag-big-opt-title { font-size: 1.05rem; font-weight: 700; line-height: 1.2; margin-bottom: 2px; color: #0B1020; }
        .suchauftrag-big-opt-desc { font-size: 12.5px; font-weight: 500; color: #6A7385; line-height: 1.4; }
        .suchauftrag-chips { display: flex; flex-wrap: wrap; gap: 9px; margin-bottom: 8px; }
        .suchauftrag-chip {
          border: 1.5px solid #E3E7F1;
          border-radius: 11px;
          background: #fff;
          padding: 11px 18px;
          font-family: 'Plus Jakarta Sans', system-ui, -apple-system, sans-serif;
          font-size: 14.5px;
          font-weight: 600;
          color: #0B1020;
          cursor: pointer;
          transition: border-color .18s, background .18s, color .18s;
          user-select: none;
        }
        .suchauftrag-chip:hover { border-color: #99A1B3; }
        .suchauftrag-chip.sel { border-color: #2F5BFF; background: #2F5BFF; color: #fff; }
        .suchauftrag-input-group { margin-bottom: 18px; }
        .suchauftrag-lbl { display: block; font-size: 11px; letter-spacing: .12em; text-transform: uppercase; color: #6A7385; margin-bottom: 8px; font-weight: 700; }
        .suchauftrag-lbl-opt { font-style: normal; font-size: 10px; letter-spacing: .04em; color: #99A1B3; text-transform: none; font-weight: 600; }
        .suchauftrag-field {
          width: 100%;
          border: 1.5px solid #E3E7F1;
          border-radius: 13px;
          padding: 14px 16px;
          font-family: 'Plus Jakarta Sans', system-ui, -apple-system, sans-serif;
          font-size: 1rem;
          font-weight: 600;
          color: #0B1020;
          background: #fff;
          outline: none;
          transition: border-color .18s, box-shadow .18s;
        }
        .suchauftrag-field:focus {
          border-color: #2F5BFF;
          box-shadow: 0 0 0 4px rgba(47,91,255,.10);
        }
        .suchauftrag-field::placeholder { color: #99A1B3; font-weight: 500; }
        .suchauftrag-row2 { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
        .suchauftrag-slider-wrap { margin-bottom: 30px; }
        .suchauftrag-slider-val {
          font-size: clamp(2rem, 5.5vw, 2.6rem);
          font-weight: 800;
          letter-spacing: -.02em;
          margin-bottom: 14px;
          color: #0B1020;
        }
        .suchauftrag-slider-val span { font-size: 1rem; font-weight: 600; color: #6A7385; margin-left: 4px; }
        .suchauftrag-range {
          -webkit-appearance: none;
          appearance: none;
          width: 100%;
          height: 6px;
          background: #E3E7F1;
          outline: none;
          border-radius: 99px;
          margin-bottom: 10px;
        }
        .suchauftrag-range::-webkit-slider-thumb {
          -webkit-appearance: none;
          width: 24px;
          height: 24px;
          border: 3px solid #FF6A2B;
          border-radius: 50%;
          background: #fff;
          cursor: pointer;
          box-shadow: 0 3px 10px rgba(0,0,0,.18);
        }
        .suchauftrag-range::-moz-range-thumb {
          width: 24px;
          height: 24px;
          border: 3px solid #FF6A2B;
          border-radius: 50%;
          background: #fff;
          cursor: pointer;
          box-shadow: 0 3px 10px rgba(0,0,0,.18);
        }
        .suchauftrag-slider-range { display: flex; justify-content: space-between; font-size: 12px; color: #6A7385; letter-spacing: .02em; font-weight: 600; }
        .suchauftrag-nav { display: flex; align-items: center; justify-content: space-between; margin-top: 40px; }
        .suchauftrag-btn-back {
          font-family: 'Plus Jakarta Sans', system-ui, -apple-system, sans-serif;
          font-size: 14px;
          letter-spacing: .01em;
          color: #6A7385;
          background: none;
          border: none;
          cursor: pointer;
          font-weight: 700;
          transition: color .18s;
        }
        .suchauftrag-btn-back:hover { color: #0B1020; }
        .suchauftrag-btn-next {
          font-family: 'Plus Jakarta Sans', system-ui, -apple-system, sans-serif;
          font-size: 16px;
          letter-spacing: .01em;
          font-weight: 800;
          background: #2F5BFF;
          color: #fff;
          border: none;
          border-radius: 14px;
          padding: 16px 36px;
          cursor: pointer;
          transition: transform .12s, box-shadow .18s, opacity .18s;
          box-shadow: 0 10px 24px rgba(47,91,255,.26);
        }
        .suchauftrag-btn-next:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 14px 30px rgba(47,91,255,.32); }
        .suchauftrag-btn-next:disabled { opacity: .32; cursor: default; box-shadow: none; transform: none; }
        .suchauftrag-trust { display: flex; gap: 22px; margin-top: 30px; padding-top: 26px; border-top: 1px solid #E3E7F1; }
        .suchauftrag-trust-item { display: flex; align-items: flex-start; gap: 9px; flex: 1; }
        .suchauftrag-trust-icon { flex-shrink: 0; width: 18px; margin-top: 1px; }
        .suchauftrag-trust-text { font-size: 12px; color: #6A7385; font-weight: 600; line-height: 1.5; }
        .suchauftrag-info-box {
          background: #EEF2FF;
          border-left: 3px solid #2F5BFF;
          border-radius: 10px;
          padding: 14px 18px;
          margin-bottom: 24px;
          font-size: 13px;
          font-weight: 500;
          color: #6A7385;
          line-height: 1.6;
        }
        .suchauftrag-confirm { text-align: center; padding: 40px 0; }
        .suchauftrag-confirm-ring {
          width: 76px;
          height: 76px;
          background: #FF6A2B;
          border: none;
          border-radius: 22px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 32px;
          box-shadow: 0 12px 30px rgba(255,106,43,.4);
        }
        .suchauftrag-confirm-title {
          font-size: clamp(1.9rem, 5vw, 2.5rem);
          font-weight: 800;
          margin-bottom: 14px;
          letter-spacing: -.02em;
        }
        .suchauftrag-confirm-sub { font-size: 15px; color: #6A7385; font-weight: 500; line-height: 1.6; max-width: 420px; margin: 0 auto 24px; font-style: normal; }
        .suchauftrag-confirm-dsgvo {
          font-size: 13px;
          color: #6A7385;
          font-weight: 500;
          line-height: 1.7;
          max-width: 460px;
          margin: 0 auto 28px;
          border-left: 3px solid #2F5BFF;
          padding: 4px 0 4px 16px;
          text-align: left;
        }
        .suchauftrag-confirm-hr { width: 40px; height: 3px; border-radius: 99px; background: #FF6A2B; margin: 0 auto 28px; }
        .suchauftrag-confirm-steps { display: flex; flex-direction: column; gap: 16px; text-align: left; max-width: 340px; margin: 0 auto; }
        .suchauftrag-confirm-step { display: flex; align-items: flex-start; gap: 14px; }
        .suchauftrag-confirm-step-num {
          width: 28px;
          height: 28px;
          background: #2F5BFF;
          color: #fff;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 13px;
          font-weight: 800;
          flex-shrink: 0;
          margin-top: 1px;
        }
        .suchauftrag-confirm-step-text { font-size: 14px; font-weight: 700; color: #0B1020; line-height: 1.4; }
        .suchauftrag-confirm-step-text span { display: block; font-weight: 500; font-style: normal; color: #6A7385; font-size: 12.5px; margin-top: 2px; }
        .suchauftrag-confirm-footer { font-size: 11px; color: #99A1B3; text-align: center; font-style: italic; margin-top: 24px; }
        .suchauftrag-confirm-footer a { color: #99A1B3; }
        .suchauftrag-dsgvo-hinweis { font-size: 12px; color: #99A1B3; text-align: center; margin-top: 20px; font-style: italic; }

        @media (max-width: 640px) {
          .suchauftrag-hero:not(.compact) .suchauftrag-inner { padding: 28px 20px 28px; }
          .suchauftrag-hero:not(.compact) .suchauftrag-row2 { grid-template-columns: 1fr; gap: 0; }
          .suchauftrag-hero:not(.compact) .suchauftrag-trust { flex-direction: column; gap: 14px; }
          .suchauftrag-hero.compact .suchauftrag-inner { padding: 20px 16px 20px; }
        }
      `}</style>

      <div className={`suchauftrag-hero${compact ? ' compact' : ''}`} style={compact ? { paddingTop: 0 } : { paddingTop: 'calc(48px + 3.5rem)' }}>
        <div className="suchauftrag-inner">
          <div className="suchauftrag-brandblock">
            <div className="suchauftrag-brand">
              <div className="suchauftrag-brand-mark">
                <svg viewBox="0 0 100 100" fill="none">
                  <path d="M16 54 L50 24 L84 54" stroke="#fff" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M28 50 V80 H72 V50" stroke="#fff" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" />
                  <rect x="44" y="62" width="12" height="18" rx="2.5" fill="#FF6A2B" />
                </svg>
              </div>
              <div className="suchauftrag-brand-text">
                <div className="suchauftrag-wordmark">IMMO<em>INTEREST</em></div>
                <div className="suchauftrag-kicker">REAL ESTATE</div>
              </div>
            </div>
            <div className="suchauftrag-brand-tag">Suchauftrag einrichten</div>
          </div>

          {!submitted && (
            <>
              <div className="suchauftrag-prog-track">
                <div className="suchauftrag-prog-fill" style={{ width: pct + "%" }} />
              </div>
              <div className="suchauftrag-prog-info">
                <div className="suchauftrag-prog-text">
                  Schritt {step} von {TOTAL_STEPS}
                </div>
                <div className="suchauftrag-prog-pct">{pct} %</div>
              </div>
            </>
          )}

          {renderCurrentStep()}
        </div>
      </div>
    </>
  );
};

export default SuchauftragSection;
